import { useParams, useNavigate } from "react-router-dom";
import { useSpecialArticle } from "@/hooks/useSpecialArticle";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";

const SpecialArticle = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { toast } = useToast();
  
  const { data: article, isLoading, error } = useSpecialArticle(slug || "");

  if (isLoading) {
    return (
      <div className="container mx-auto p-6 text-center">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-3/4 mx-auto mb-4" />
          <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto mb-8" />
          <div className="space-y-4">
            <div className="h-4 bg-gray-200 rounded" />
            <div className="h-4 bg-gray-200 rounded" />
            <div className="h-4 bg-gray-200 rounded" />
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    toast({
      variant: "destructive",
      title: "エラーが発生しました",
      description: "記事の取得に失敗しました。",
    });

    return (
      <div className="container mx-auto p-6 text-center">
        <h1 className="text-2xl font-bold mb-4 text-elegant-dark">
          記事が見つかりません
        </h1>
        <Button onClick={() => navigate("/")} variant="outline">
          トップページに戻る
        </Button>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="container mx-auto p-6 text-center">
        <h1 className="text-2xl font-bold mb-4 text-elegant-dark">
          記事が見つかりません
        </h1>
        <Button onClick={() => navigate("/")} variant="outline">
          トップページに戻る
        </Button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        {/* ヒーローセクション */}
        <div className="mb-8 glass-card p-8 rounded-lg">
          <div className="flex items-center gap-2 mb-4">
            <h1 className="text-4xl font-bold text-elegant-dark">
              {article.title}
            </h1>
          </div>
          {article.image_url && (
            <div className="relative h-96 rounded-lg overflow-hidden elegant-shadow">
              <img
                src={article.image_url}
                alt={article.title}
                className="object-cover w-full h-full"
              />
            </div>
          )}
        </div>

        {/* メインコンテンツ */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          <article className="lg:col-span-3 prose prose-elegant max-w-none">
            <div className="leading-relaxed whitespace-pre-wrap bg-white/80 backdrop-blur-sm p-8 rounded-lg elegant-shadow">
              {article.content}
            </div>
          </article>

          {/* サイドバー */}
          <aside className="lg:col-span-1">
            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-lg elegant-shadow">
              <h2 className="text-xl font-bold mb-4 text-elegant">概要</h2>
              <p className="text-elegant/80 leading-relaxed">
                {article.excerpt}
              </p>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default SpecialArticle;